const Images = {
  apple: require("../Images/apples.jpg").default,
  cashews: require("../Images/cashews.jpg").default,
  chiaSeeds: require("../Images/chia seeds.jpg").default,
  mixedNuts: require("../Images/mixed nuts.jpg").default,
  oats: require("../Images/oats 2.jpg").default,
  quinoa: require("../Images/quinoa.jpg").default,
  strawberries: require("../Images/strawberries.jpg").default,
  sunflowerSeeds: require("../Images/sunflowerSeeds.jpg").default,
  flaxSeeds: require("../Images/flax seeds.jpg").default,
  mangoes: require("../Images/mangoes.jpg").default,
  onions: require("../Images/onions.jpg").default,
  spinach: require("../Images/spinach.jpg").default,
};

export { Images };
